import React from 'react';
import { ArrowDown } from 'lucide-react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
export function HeroSection() {
  const scrollToCheckout = () => {
    document.getElementById('checkout')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const bookImage = <motion.div initial={{
    opacity: 0,
    scale: 0.9
  }} animate={{
    opacity: 1,
    scale: 1
  }} transition={{
    duration: 0.6
  }} className="relative" data-id="element-139">
      <div className="absolute inset-0 bg-green-500/20 blur-[100px] rounded-full pointer-events-none" data-id="element-140" />
      <img src="https://cdn.magicpatterns.com/uploads/kvea649PjUmu3tHoiMp7QR/ChatGPT_Image_24_feb_2026,_15_07_28_(1)_(1).png" alt="Huerta Productiva 360° — Manual Principal" width={448} height={448} fetchPriority="high" loading="eager" decoding="async" className="relative z-10 w-full max-w-md mx-auto rounded-xl shadow-2xl border border-zinc-800 rotate-3 hover:rotate-0 transition-transform duration-500" data-id="element-141" />
    </motion.div>;
  return <section className="relative min-h-screen flex items-center justify-center pt-24 pb-16 px-4 overflow-hidden bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-zinc-900 via-black to-black" data-id="element-142">
      <svg className="absolute inset-0 w-full h-full opacity-[0.08] pointer-events-none" xmlns="http://www.w3.org/2000/svg" data-id="element-143">
        <filter id="heroNoise" data-id="element-144">
          <feTurbulence type="fractalNoise" baseFrequency="0.65" numOctaves="4" stitchTiles="stitch" data-id="element-145" />
        </filter>
        <rect width="100%" height="100%" filter="url(#heroNoise)" data-id="element-146" />
      </svg>

      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-147">
        <div className="text-center lg:text-left" data-id="element-148">
          <div className="inline-block bg-green-500/10 border border-green-500/20 rounded px-3 py-1 mb-6" data-id="element-149">
            <span className="text-green-500 font-bold uppercase tracking-wider text-sm" data-id="element-150">
              🔥 +800 personas ya están produciendo su propia comida
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl font-black text-white leading-tight mb-6" data-id="element-151">
            Producí tus propios alimentos{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-green-600" data-id="element-152">
              todo el año
            </span>
            , aunque nunca hayas plantado nada.
          </h1>

          {/* Image shown on mobile only, right after the headline */}
          <div className="lg:hidden mb-8" data-id="element-153">{bookImage}</div>

          <p className="text-xl text-gray-400 mb-8 max-w-xl mx-auto lg:mx-0 leading-relaxed" data-id="element-154">
            Un sistema paso a paso que te dice qué plantar, cuándo y cómo —
            desde el primer día. Sin experiencia, sin patio grande, sin
            complicarte.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-155">
            <div className="flex flex-col items-center lg:items-start gap-2" data-id="element-156">
              <Button size="xl" onClick={scrollToCheckout} className="group" data-id="element-157">
                ACCEDE AHORA MISMO
                <ArrowDown className="ml-2 w-5 h-5 group-hover:translate-y-1 transition-transform" data-id="element-158" />
              </Button>
              <p className="text-zinc-500 text-xs" data-id="element-159">
                📧 Descarga inmediata · Pago seguro con Mercado Pago · Garantía
                7 días
              </p>
            </div>
          </div>

          <div className="mt-8 flex items-center justify-center lg:justify-start gap-4 text-sm text-zinc-500" data-id="element-160">
            <div className="flex -space-x-2" data-id="element-161">
              {[1, 2, 3, 4].map(i => <div key={i} className="w-8 h-8 rounded-full bg-zinc-800 border-2 border-black flex items-center justify-center text-xs text-white font-bold" data-id="element-162">
                  {String.fromCharCode(64 + i)}
                </div>)}
            </div>
            <p data-id="element-163">+800 huertas activas en Argentina</p>
          </div>
        </div>

        {/* Image shown on desktop only, in the right column */}
        <div className="hidden lg:block" data-id="element-164">{bookImage}</div>
      </div>
    </section>;
}